import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../../actionTypes';

const initialState = {
  isFetching: false,
  isVisible: false,
  apiError: null,
  code: null,
};

const open = (state, { payload }) => ({
  ...state,
  code: payload.code,
  vaultId: payload.vaultId,
  isVisible: true,
  apiError: null,
});

const close = state => ({
  ...state,
  code: null,
  isVisible: false,
  apiError: null,
});

const setCode = (state, { payload: code }) => ({
  ...state,
  code,
});

const beforeSend = state => ({
  ...state,
  apiError: null,
  isFetching: true,
});

const onError = (state, { payload: message }) => ({
  ...state,
  isFetching: false,
  apiError: message,
});

const afterSave = state => ({
  ...state,
  isVisible: false,
  isFetching: false,
});

export default createReducer(initialState, {
  [actionTypes.OPEN_CODE_MODAL]: open,
  [actionTypes.CLOSE_CODE_MODAL]: close,
  [actionTypes.SET_UPDATING_CODE]: setCode,
  [actionTypes.FETCH_GENERATE_CODE_SUCCESS]: setCode,
  [actionTypes.PATCH_CODE_REQUEST]: beforeSend,
  [actionTypes.PATCH_CODE_FAILURE]: onError,
  [actionTypes.PATCH_CODE_SUCCESS]: afterSave,
});
